import React from 'react';
import {
  Divider,
  EmptyView,
  Flex,
  IconBlind,
  List,
  PrimaryButton,
  Spinner,
} from '@banhala/ui-kit';
import { useGoodsReviews } from '../../queries/useGoodsReviews';
import { ReviewCard } from './ReviewCard';
import { useAppDownloadModal, useOpenDeeplink } from 'shared/src/hooks';

const ReviewListContent: React.FC = () => {
  const { data: goodsReviews } = useGoodsReviews();
  const { openDeeplink } = useOpenDeeplink();

  const { show: openModal } = useAppDownloadModal();

  if (goodsReviews.reviews.length === 0) {
    return (
      <Flex.Center height={200}>
        <EmptyView title={'아직 등록된 리뷰가 없어요'} icon={<IconBlind />} />
      </Flex.Center>
    );
  }

  return (
    <List
      data={goodsReviews.reviews}
      scrollEnabled={false}
      renderItem={({ item }) => (
        <ReviewCard
          review={item}
          onPressImage={index => {
            openDeeplink(
              `ably://reviews/${item.sno}/photo?photo_index=${index}`,
            );
          }}
        />
      )}
      ItemSeparatorComponent={() => <Divider size={'medium'} />}
      ListFooterComponent={() => (
        <Flex padding={{ horizontal: 14 }}>
          <PrimaryButton
            variant={'fill'}
            size={'medium'}
            outline
            onPress={() => {
              openModal();
            }}
          >
            앱에서 리뷰 전체보기
          </PrimaryButton>
        </Flex>
      )}
    />
  );
};
export const ReviewList: React.FC = props => {
  return (
    <React.Suspense
      fallback={
        <Flex.Center height={300}>
          <Spinner size={24} />
        </Flex.Center>
      }
    >
      <ReviewListContent {...props} />
    </React.Suspense>
  );
};
